import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X, Instagram } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { label: "Our Work", href: "#work" },
  { label: "Pricing", href: "#pricing" },
  { label: "Flavors", href: "#flavors" },
  { label: "About", href: "#about" },
  { label: "FAQ", href: "#faq" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const go = (href) => {
    setOpen(false);
    scrollToId(href);
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className="fixed inset-x-0 top-0 z-50 border-b border-[#E8D8D3]/70 bg-[#FDFBF7]/90 backdrop-blur-md"
      data-testid="navbar"
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 sm:px-8">
        <button
          onClick={() => go("#top")}
          className="flex items-center gap-3"
          data-testid="nav-logo"
          aria-label="Bella Bells Cakes home"
        >
          <img
            src="/logo.png"
            alt="Bella Bells Cakes"
            className="h-12 w-auto mix-blend-multiply"
          />
        </button>

        <nav className="hidden items-center gap-8 lg:flex" data-testid="nav-links">
          {LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => go(l.href)}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="font-accent text-[13px] font-medium uppercase tracking-[0.18em] text-[#5C4B47] transition-colors duration-300 hover:text-[#C48B71]"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden items-center gap-5 lg:flex">
          <a
            href="https://www.instagram.com/bellabellscakes"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            data-testid="nav-instagram-link"
            className="text-[#5C4B47] transition-colors duration-300 hover:text-[#C48B71]"
          >
            <Instagram size={19} strokeWidth={1.5} />
          </a>
          <button onClick={() => go("#inquiry")} className="btn-primary !px-6 !py-2.5" data-testid="nav-request-cake-btn">
            Request a Cake
          </button>
        </div>

        <button
          className="text-[#2D2422] lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-menu-btn"
        >
          {open ? <X size={24} strokeWidth={1.5} /> : <Menu size={24} strokeWidth={1.5} />}
        </button>
      </div>

      {open && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          className="border-t border-[#E8D8D3] bg-[#FDFBF7] lg:hidden"
          data-testid="nav-mobile-menu"
        >
          <div className="flex flex-col gap-1 px-6 py-6">
            {LINKS.map((l) => (
              <button
                key={l.href}
                onClick={() => go(l.href)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="py-3 text-left font-display text-2xl text-[#2D2422]"
              >
                {l.label}
              </button>
            ))}
            <button onClick={() => go("#inquiry")} className="btn-primary mt-4 w-full" data-testid="nav-mobile-request-cake-btn">
              Request a Cake
            </button>
          </div>
        </motion.div>
      )}
    </motion.header>
  );
};

export default Navbar;
